export const contactNumber = '8889788625';

export enum TagTheme {
	AspenDental = 'aspendental',
	AzPetVet = 'azPetVet',
	TeamTag = 'teamTag',
	WellNow = 'wellnow',
	Chapter = 'chapter',
	ClearChoice = 'clearchoice',
}

export enum SubmitAppointmentErrorCode {
	CONSULT_SCHEDULED = 'consult_scheduled',
	NO_APPOINTMENTS = 'no_appointments',
}

export enum HydraState {
	OFF = 'OFF',
	ON = 'ON',
}

export enum RequestHeaders {
	SESSION_ID = 'X-Session-Id',
	HYDRA = 'hydra',
}

// names based on this information: https://aspendent.atlassian.net/browse/DCP-3057
export enum FormIdMappings {
	formID = '4d2ed60e-6463-11ef-bff5-0192d98a2726',
	// form with 3 dental questions
	formID3DentalQuestions = 'ca4c8298-befa-11ef-8f60-45af9e09548c',
}

export const DENTURE_OR_PARTIAL_DENTURE_SHORT_NAME = 'denture';
export const DENTAL_IMPLANT_SHORT_NAME = 'implant';
export const GOOGLE_RESERVE_PARTNER_ID = 20002677;

export const CACHE_CONTROL_NO_CACHE = 'no-cache, no-store, must-revalidate';
export const SENTRY_DSN =
	'https://38d5354a51817674bfc40d307d662f1e@o4508615315554304.ingest.us.sentry.io/4509005919748096';
